import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useRoundedInputStyles } from './styles';
import { COLORS } from '../../utils/colors';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface InputProps {
  label?: string;
  error?: boolean;
  errorText?: string;
  value: string;
  type?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  maxLength?: number;
  size?: 'small' | 'medium';
  name?: string;
  disabled?: boolean;
  sx?: object;
}

const RoundedInput = ({
  label,
  error,
  errorText,
  value,
  type,
  onChange,
  maxLength,
  size,
  name,
  disabled,
  sx,
}: InputProps) => {
  const roundedInputStyles = useRoundedInputStyles();
  const [isFocused, setIsFocused] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const handleClickShowPassword = () =>
    setIsPasswordVisible(!isPasswordVisible);
  const handleMouseDownPassword = () =>
    setIsPasswordVisible(!isPasswordVisible);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <Box my={1.5} sx={sx}>
      <TextField
        fullWidth
        variant="outlined"
        label={label}
        error={error}
        value={value}
        autoComplete={type === 'number' ? undefined : type}
        InputLabelProps={{
          shrink: isFocused || !!value,
        }}
        inputProps={{
          maxLength: maxLength,
        }}
        type={type === 'password' && isPasswordVisible ? 'text' : type}
        helperText={
          error ? (
            <span style={{ color: COLORS.BACKGROUND, fontWeight: '600' }}>
              {errorText}
            </span>
          ) : (
            ''
          )
        }
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        size={size}
        name={name}
        disabled={disabled}
        InputProps={{
          endAdornment: type === 'password' && (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}>
                {isPasswordVisible ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default RoundedInput;
